import { useUpdateItemsInCart } from "@/hooks/useCart";
import { useAlterCollection } from "@/hooks/useCollection";
import useTranslation from "@/hooks/useTranslation";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import MuiAlert, { AlertProps } from "@material-ui/lab/Alert";
import { message, Spin } from "antd";
import React from "react";

function Alert(props: AlertProps) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

interface IProps {
  open: boolean;
  handleClose: () => void;
  handleUpperClose: () => void;
  collectionName: string;
  ids: string[];
  collectionId: string;
}

const ConfirmDialog: React.FC<IProps> = ({
  open,
  handleClose,
  collectionName,
  collectionId,
  ids,
  handleUpperClose,
}) => {
  const { t } = useTranslation("common");
  const {
    alterCollection,
    loading: loadingAlterCollection,
  } = useAlterCollection();

  const {
    updateItemsInCart,
    loading: loadingUpdateCart,
  } = useUpdateItemsInCart();

  const handleMutate = async (ids: string[], collectionId: string) => {
    await updateItemsInCart(ids);
    await alterCollection({ collectionId, paperIds: ids });
    message.success(t("bundle:cart.add.success"));
    handleClose();
    handleUpperClose();
  };

  return (
    <Spin spinning={loadingAlterCollection || loadingUpdateCart} delay={500}>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{t("bundle:cart.add.to-collection")}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {t("bundle:cart.add.confirm")} {collectionName} {"?"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="default">
            {t("cancel")}
          </Button>
          <Button
            onClick={() => handleMutate(ids, collectionId)}
            color="primary"
            autoFocus
          >
            {t("submit")}
          </Button>
        </DialogActions>
      </Dialog>
    </Spin>
  );
};

export default ConfirmDialog;
